import {
  getAgentsByMerchantId,
  getAgentsProcessingConfigLendersByMerchantId,
  getAgentsProcessingConfigOptionsByMerchantId,
  LenderName,
  patchSetProcessingConfigToMerchantAgents,
  PaymentMethodType,
} from '@nemuru-eng/js-api-client';
import { useMemo } from 'react';

import { MerchantOrchestrationMap } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/maps/merchantOrchestration.map';
import { OrchestrationConfig } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/OrchestrationConfig';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

export const useMerchantLenderOrchestration = (merchantId: string) => {
  const agentsCache = useCache(getAgentsByMerchantId, { merchantId });
  const optionsCache = useCache(getAgentsProcessingConfigOptionsByMerchantId, { merchantId });
  const lendersCache = useCache(getAgentsProcessingConfigLendersByMerchantId, { merchantId });
  const { request, loading: applying } = useRequest();

  const rows = useMemo(() => MerchantOrchestrationMap.toRows(agentsCache.data ?? []), [agentsCache.data]);
  const lendersByPaymentMethodType = (lendersCache.data ?? {}) as Partial<Record<PaymentMethodType, LenderName[]>>;

  const apply = async (paymentMethodType: PaymentMethodType, config: OrchestrationConfig) => {
    await request(patchSetProcessingConfigToMerchantAgents, { merchantId, paymentMethodType, ...config });
    await agentsCache.revalidate();
  };

  return {
    rows,
    lendersByPaymentMethodType,
    options: optionsCache.data,
    loading: agentsCache.loading || optionsCache.loading || lendersCache.loading,
    loaded: agentsCache.data !== undefined,
    error: Boolean(agentsCache.error || optionsCache.error),
    lendersError: Boolean(lendersCache.error),
    apply,
    applying,
  };
};
